import request from "../../../network/request";

/**
 * app 通用 BaseCode 配置查询（新，4.15）
 * 服务：xp-ass-toc
 * POST /public/v1/module/maintenance/basecode/list  { typeSet: string[] } → BaseCodeItem[]
 * typeSet 如：["T1_NO_RECURRENT_NOTICE"]
 * 出参每项：{ type, code, desc, remark, orderBy }
 */
export interface BaseCodeItem {
  type: string;
  code: string;
  desc: string; // 展示文案（后端 desc，兼容旧字段 codeDesc）
  remark?: string;
  orderBy?: number;
}

/**
 * 批量查询多个字典类型，返回按 type 分组的 map（后端已按顺序返回，保持原序）。
 * @param types  需查询的字典类型
 * @param options.rethrow  为 true 时请求失败不吞异常，向上抛出（供需要错误态/提示的调用方使用）；
 *                         默认 false，失败静默返回空 map（保持原行为，供非阻塞的开关类查询使用）。
 */
export async function fetchBaseCodes(
  types: string[],
  options?: { rethrow?: boolean }
): Promise<Record<string, BaseCodeItem[]>> {
  let list: any[] = [];
  try {
    const data: any = await request(
      "module/maintenance/basecode/list",
      { typeSet: types },
      "POST"
    );
    list = Array.isArray(data) ? data : [];
  } catch (e) {
    if (options?.rethrow) throw e;
    list = [];
  }

  const map: Record<string, BaseCodeItem[]> = {};
  list.forEach((it) => {
    const item: BaseCodeItem = {
      type: it.type,
      code: String(it.code),
      desc: it.desc ?? it.codeDesc ?? "",
      remark: it.remark,
      orderBy: it.orderBy,
    };
    (map[item.type] = map[item.type] || []).push(item);
  });

  return map;
}
